import makeStyles from "@material-ui/styles/makeStyles";
import PropTypes from "prop-types";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

// Copy of AlertDialog (src/components/AlertDialog), forked so PII dialog
// styling can diverge without affecting AlertDialog's other call sites.
const useStyles = makeStyles({
  paper: {
    width: 440,
    maxWidth: 440,
    borderRadius: 8,
  },
  // The Figma spec treats title/body/footer as one 24px-padded auto-layout
  // frame with a uniform 16px gap between each section. Dialog/DialogTitle/
  // DialogContent/DialogActions are 3 separately-padded boxes instead, so
  // the padding below is split to add up to the spec's values at each seam:
  // dialogTitle's bottom (0) + dialogContent's top (16) = 16px title->body
  // gap; dialogContent's bottom (0) + dialogActions' top (16) = 16px
  // body->footer gap. Assumes body always follows title (true for the only
  // current caller, PiiOverrideDialog) - a future `header`-only usage would
  // need its own padding split.
  dialogTitle: {
    padding: "24px 24px 0 24px",
    // MUI's DialogTitle renders its children inside its own nested
    // <Typography variant="h6">, not directly in this root element -
    // fontWeight here only sets an *inherited* value, and MuiTypography-h6
    // has its own explicit font-weight: 500 (theme.typography.fontWeightMedium)
    // that overrides inheritance regardless of !important on the ancestor.
    // Target the nested Typography's class directly instead.
    "& .MuiTypography-root": {
      fontWeight: "600 !important",
    },
  },
  dialogContent: {
    padding: "16px 24px 0 24px",
  },
  dialogActions: {
    padding: "16px 24px 24px 24px",
    gap: "16px",
  },
});

export default function PiiAlertDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const handleClose = val => {
    onClose(val);
  };

  //

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="pii-alert-dialog-title"
      aria-describedby="pii-alert-dialog-description"
      style={{ zIndex: 1300 }}
      {...props}
      classes={{ paper: classes.paper }}
    >
      {props.title && (
        <DialogTitle id="pii-alert-dialog-title" className={classes.dialogTitle}>
          {props.title}
        </DialogTitle>
      )}
      {props.header && (
        <DialogActions disableSpacing className={classes.dialogActions}>
          {props.header}
        </DialogActions>
      )}

      <DialogContent className={classes.dialogContent}>
        <DialogContentText component="span" id="pii-alert-dialog-description">
          {props.body}
        </DialogContentText>
      </DialogContent>
      {props.footer && (
        <DialogActions disableSpacing className={classes.dialogActions}>
          {props.footer}
        </DialogActions>
      )}
    </Dialog>
  );
}

PiiAlertDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
